import { useEffect, useState } from 'react'

/**
 * Returns a debounced value that updates after the specified delay.
 * @param value - Source value to debounce.
 * @param delay - Optional delay in milliseconds before emitting updates.
 * @returns Latest value after the debounce timer elapses.
 */
export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}


